import { TargetPayloadType } from 'storeTypes'
import { InteractionOutcomes } from 'types'

export const sortTargetList = (targetList: TargetPayloadType[]) => {
    return targetList.sort((a, b) => {
        if (a.duplicate || b.duplicate) {
            return Number(a.duplicate) - Number(b.duplicate)
        }
        const aNoOutcome = a.outcome == null
        const bNoOutcome = b.outcome == null
        if (aNoOutcome !== bNoOutcome) {
            return aNoOutcome ? -1 : 1
        }
        if (a.outcome === InteractionOutcomes.NOT_INTERESTED) return 1
        if (b.outcome === InteractionOutcomes.NOT_INTERESTED) return -1
        return 0
    })
}
